var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImageHome2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 300,
    viewBox: "0 0 360 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_192_10401)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    y: -1,
    width: 360,
    height: 300,
    fill: "#EE6C4D"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_192_10401)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283.299 193.169C282.988 192.806 282.756 192.375 282.62 191.906C282.484 191.438 282.446 190.944 282.51 190.458C282.574 189.973 282.737 189.508 282.989 189.097C283.241 188.686 283.575 188.338 283.967 188.078L281.456 176.467L286.934 178.636L288.479 189.329C288.847 190.056 288.952 190.901 288.771 191.704C288.591 192.506 288.138 193.211 287.5 193.684C286.861 194.157 286.081 194.366 285.307 194.271C284.532 194.176 283.818 193.784 283.299 193.169Z",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.92 183.953L278.104 174.1L278.756 149.29L279.065 149.98C279.426 150.783 287.875 169.714 287.272 176.051L288.238 181.843L282.92 183.953Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.78 256.771H283.641L285.478 241.008L279.779 241.009L279.78 256.771Z",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.795 255.437L286.399 255.437H286.4C287.685 255.437 288.917 255.977 289.826 256.939C290.735 257.9 291.245 259.205 291.245 260.565V260.732L278.795 260.732L278.795 255.437Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.629 253.665L245.349 254.76L251.109 240.095L245.619 238.479L241.629 253.665Z",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.017 252.101L248.343 254.257L248.344 254.257C249.582 254.621 250.633 255.491 251.265 256.676C251.897 257.86 252.059 259.261 251.714 260.572L251.672 260.732L239.677 257.203L241.017 252.101Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.93 250.626L268.137 191.574L251.306 250.292L238.072 245.51L257.04 166.885L257.165 166.875L277.035 165.413L291.391 245.854L275.93 250.626Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.869 139.058C273.869 139.058 266.625 135.058 256.861 136.725C256.861 136.725 251.665 149.994 256.861 155.276L258.279 168.558C258.279 168.558 271.507 176.891 275.916 167.225L275.286 156.225C275.286 156.225 278.436 150.949 275.916 147.087C274.406 144.728 273.685 141.902 273.869 139.058Z",
    fill: "#EE6C4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.787 199.472L276.058 171.549L272.46 138.332L272.625 138.306C277.345 137.553 278.859 146.159 278.921 146.526L287.137 195.688L274.787 199.472Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.769 199.763L244.244 198.055L244.248 197.887C244.299 195.611 245.55 142.105 249.053 138.315C252.576 134.503 259.225 136.153 259.507 136.225L259.647 136.261L258.452 158.902L258.769 199.763Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.444 167.784C261.004 167.936 260.537 167.985 260.078 167.927C259.618 167.868 259.176 167.704 258.783 167.445C258.39 167.186 258.055 166.839 257.802 166.428C257.55 166.018 257.385 165.554 257.32 165.068L246.275 162.778L250.374 158.362L260.234 161.214C261.011 161.153 261.783 161.395 262.402 161.896C263.022 162.397 263.447 163.12 263.596 163.93C263.745 164.74 263.608 165.58 263.212 166.29C262.815 167 262.186 167.532 261.444 167.784Z",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.55 165.103L251.951 164.284C246.638 165.975 237.364 160.022 233.616 157.378C232.911 156.88 232.682 155.894 232.936 154.448C233.311 152.425 234.365 150.613 235.903 149.348L249.103 138.271L252.435 137.681L253.425 143.616L245.014 153.177L257.395 160.309L255.55 165.103Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.127 131.7V124.004C254.127 120.748 255.349 117.625 257.525 115.323C259.7 113.02 262.651 111.727 265.728 111.727C268.804 111.727 271.755 113.02 273.931 115.323C276.106 117.625 277.328 120.748 277.328 124.004V131.7C277.328 132.138 277.163 132.557 276.871 132.866C276.579 133.175 276.183 133.349 275.77 133.35H255.685C255.272 133.349 254.876 133.175 254.584 132.866C254.292 132.557 254.127 132.138 254.127 131.7Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.261 133.274C269.958 133.274 273.766 129.244 273.766 124.272C273.766 119.301 269.958 115.271 265.261 115.271C260.564 115.271 256.756 119.301 256.756 124.272C256.756 129.244 260.564 133.274 265.261 133.274Z",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.523 124.237C256.442 124.138 256.382 124.022 256.347 123.896C256.312 123.77 256.303 123.637 256.32 123.507L257.328 116.082C257.348 115.931 257.403 115.787 257.489 115.665C257.574 115.542 257.687 115.444 257.818 115.379C262.96 112.831 268.175 112.828 273.318 115.369C273.454 115.437 273.571 115.542 273.658 115.673C273.745 115.804 273.798 115.956 273.812 116.115L274.485 123.55C274.496 123.677 274.483 123.805 274.445 123.926C274.406 124.048 274.345 124.159 274.264 124.254C274.183 124.348 274.084 124.424 273.973 124.475C273.863 124.527 273.744 124.554 273.623 124.554H271.917C271.753 124.553 271.592 124.503 271.453 124.41C271.314 124.316 271.203 124.183 271.133 124.025L270.397 122.356C270.349 122.248 270.27 122.159 270.17 122.103C270.071 122.047 269.957 122.026 269.845 122.045C269.734 122.064 269.631 122.12 269.553 122.206C269.475 122.291 269.425 122.402 269.411 122.52L269.265 123.751C269.239 123.972 269.137 124.176 268.979 124.324C268.821 124.472 268.617 124.553 268.406 124.554H257.177C257.053 124.554 256.931 124.525 256.818 124.471C256.705 124.416 256.604 124.337 256.523 124.237Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.805 53.7939H30V179.543H220.805V53.7939Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7408 78.019H42.7949V102.059H77.7408V78.019Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.164 78.019H86.2178V102.059H121.164V78.019Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.587 78.019H129.641V102.059H164.587V78.019Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.009 78.019H173.063V102.059H208.009V78.019Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7408 112.045H42.7949V136.086H77.7408V112.045Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.164 112.045H86.2178V136.086H121.164V112.045Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.587 112.045H129.641V136.086H164.587V112.045Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.009 112.045H173.063V136.086H208.009V112.045Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7408 146.072H42.7949V170.112H77.7408V146.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.164 146.072H86.2178V170.112H121.164V146.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.587 146.072H129.641V170.112H164.587V146.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.009 146.072H173.063V170.112H208.009V146.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9724 68.5882C82.8674 68.5882 85.2142 66.1044 85.2142 63.0404C85.2142 59.9765 82.8674 57.4927 79.9724 57.4927C77.0773 57.4927 74.7305 59.9765 74.7305 63.0404C74.7305 66.1044 77.0773 68.5882 79.9724 68.5882Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.638 68.5882C169.533 68.5882 171.88 66.1044 171.88 63.0404C171.88 59.9765 169.533 57.4927 166.638 57.4927C163.743 57.4927 161.396 59.9765 161.396 63.0404C161.396 66.1044 163.743 68.5882 166.638 68.5882Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0695 39H77.876V64.5197H82.0695V39Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.735 39H164.542V64.5197H168.735V39Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.439 90.0395C198.438 92.0479 197.751 93.9883 196.506 95.5039C195.261 97.0196 193.54 98.0088 191.661 98.2897C189.782 98.5706 187.87 98.1245 186.277 97.0332C184.684 95.9419 183.517 94.2788 182.989 92.3494C182.462 90.4201 182.61 88.3541 183.406 86.5311C184.203 84.7081 185.594 83.2505 187.325 82.4262C189.055 81.6019 191.009 81.4662 192.826 82.0441C194.644 82.6219 196.203 83.8746 197.218 85.5718C198.017 86.9083 198.441 88.4578 198.439 90.0395Z",
    fill: "#EE6C4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.218 85.5716L189.439 93.8029C188.95 93.0019 186.227 89.279 186.227 89.279C186.576 88.9056 186.948 88.5576 187.342 88.2373L189.6 91.4246L196.307 84.3262C196.647 84.7099 196.952 85.1269 197.218 85.5716Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.594 124.065C111.592 126.074 110.905 128.014 109.66 129.53C108.415 131.045 106.695 132.035 104.816 132.316C102.937 132.597 101.025 132.15 99.4316 131.059C97.8384 129.968 96.6709 128.305 96.1435 126.375C95.616 124.446 95.7642 122.38 96.5607 120.557C97.3572 118.734 98.7486 117.276 100.479 116.452C102.21 115.628 104.163 115.492 105.981 116.07C107.798 116.648 109.358 117.9 110.372 119.598C111.172 120.934 111.595 122.484 111.594 124.065Z",
    fill: "#EE6C4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.373 119.598L102.594 127.829C102.105 127.028 99.3809 123.305 99.3809 123.305C99.7299 122.932 100.102 122.584 100.496 122.264L102.755 125.451L109.462 118.353C109.802 118.736 110.107 119.153 110.373 119.598Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1709 124.065C68.1691 126.074 67.4825 128.014 66.2373 129.53C64.9921 131.046 63.2719 132.035 61.3928 132.316C59.5137 132.597 57.6019 132.15 56.0088 131.059C54.4156 129.968 53.248 128.305 52.7206 126.375C52.1932 124.446 52.3414 122.38 53.1379 120.557C53.9344 118.734 55.3257 117.276 57.0563 116.452C58.7869 115.628 60.7404 115.492 62.5579 116.07C64.3754 116.648 65.9348 117.9 66.9496 119.598C67.7487 120.934 68.1723 122.484 68.1709 124.065Z",
    fill: "#EE6C4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9487 119.598L59.1698 127.829C58.6809 127.028 55.957 123.305 55.957 123.305C56.3061 122.932 56.6786 122.584 57.072 122.264L59.3307 125.451L66.0378 118.353C66.3779 118.736 66.683 119.153 66.9487 119.598Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.654 261H197.718C197.627 261 197.538 260.961 197.474 260.893C197.409 260.824 197.372 260.731 197.372 260.634C197.372 260.536 197.409 260.443 197.474 260.374C197.538 260.306 197.627 260.267 197.718 260.267H329.654C329.746 260.267 329.834 260.306 329.899 260.374C329.964 260.443 330 260.536 330 260.634C330 260.731 329.964 260.824 329.899 260.893C329.834 260.961 329.746 261 329.654 261Z",
    fill: "#3F3D56"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_192_10401"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 300,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_192_10401"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 222,
    fill: "white",
    transform: "translate(30 39)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageHome2);
export default __webpack_public_path__ + "static/media/ImageHome2.1476a1a621b99a4984a9aa00f7315b06.svg";
export { ForwardRef as ReactComponent };